module.exports = __webpack_public_path__ + "images/aab7db8a221ca79993c425da4f73f605.png";